import { useEffect, useState } from 'react';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { servicesApiKeyStore } from '../../../../api/masters/services-api-key-store';
import { unitsApiKeyStore } from '../../../../api/units-api-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { useLoadData } from '../../../../hooks/useLoadData';
import { useSaveData } from '../../../../hooks/useSaveData';
import { ApiResponse } from '../../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { UnitsCustomGridCell } from '../../../units/units-custom-grid-cell';
import { columns } from './lots-grid-columns';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../../../hooks/use-debounce';
import { Unit } from '../../../../models/unit';

interface ProjectsTabProps {
  customerID: number;
}
export const LotsTab = ({ customerID }: ProjectsTabProps) => {
  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Customer Details', 'Unit'));

  const {
    isLoading,
    data: units,
    refetch,
  } = useLoadData<ApiResponse<Unit[]>>(unitsApiKeyStore.getCustomerUnits(customerID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredUnits, setFilteredUnits] = useState<any[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredUnitList = units?.data?.filter((unit) =>
      Object.values(unit).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredUnits(filteredUnitList || []);
  }, [debouncedSearchTerm, units?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Unit',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Unit',
      pageName: 'Customer Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);
  return (
    <SiTrackGrid
    fileTitle='customer_lot'
      columns={columns}
      dataItemKey="unitID"
      // queryConfig={unitsApiKeyStore.getCustomerUnits(customerID)}
      viewRoute={(value) => `/units/profile/${value.unitID}`}
      customCell={(field) =>
        UnitsCustomGridCell({
          field,
        })
      }
      actionPermissions={{
        view: UserPermissionName.VIEW_UNIT,
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      // -----------------Grid Layout-------
      dataItems={filteredUnits || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
      // -----------------Grid Layout-------
    />
  );
};
